var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-col',{staticClass:"detail-claim",attrs:{"cols":"12"}},[_c('p',{staticClass:"mb-0 fs-09",domProps:{"innerHTML":_vm._s(_vm.detailClaim)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }